import { useMemo } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import s from './AudienceInfoModal.module.scss'

import { useFetch } from 'hooks/useFetch'

import { useDeviceContext } from 'contexts/DeviceContext'

import { audienceApi } from 'api/audience-api'

import { ExclamationIcon } from 'assets/icons/ExclamationIcon'
import { ImageIcon } from 'assets/icons/ImageIcon'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { CustomSlider } from 'components/UI/CustomSlider/CustomSlider'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

const AudienceInfoModal = () => {
  const [searchParams] = useSearchParams()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { deviceWidth } = useDeviceContext()
  const { data: audience, loading } = useFetch({
    getData: () => audienceApi.getOne(+(id || 0)),
  })
  const images = useMemo(
    () =>
      audience?.seg_rules?.length
        ? audience?.seg_rules
            .map((rule) => rule.seg_rule_creatives.map((item) => item.creative.thumbnail))
            .reduce((k, v) => [...k, ...v], [])
        : [],
    [audience?.seg_rules?.length]
  )

  const onCloseModal = () => {
    navigate(`../?${searchParams}`, { replace: true })
  }

  const editAudienceHandler = () => {
    navigate(`../edit/${id}?${searchParams}`)
  }

  return (
    <ModalFullScreen onHide={onCloseModal} loading={loading} className={s.modalWrapper}>
      <div></div>
      <div className={s.wrapper}>
        <CustomSlider
          images={images}
          itemStyle={deviceWidth > 600 ? { height: '21.125rem', width: '37.5rem' }: { width: '100%', height: '21.125rem', maxWidth: '34.5rem'}}
          style={deviceWidth > 600 ? { width: '37.5rem', height: '21.125rem' }: { width: '100%', height: '21.125rem', maxWidth: '34.5rem'}}
        />
        <div className={s.info}>
          <h3 className={s.title}>{audience?.name}</h3>
          <p className={s.text}>{audience?.description}</p>
          <div className={s.rulesAndCreativesWrapper}>
            <div className={s.rules}>
              <ExclamationIcon className={s.descriptionIcon} />
              {audience?.seg_rules?.length} Rules applied
            </div>
            <div className={s.creatives}>
              <ImageIcon className={s.descriptionIcon} />
              {audience?.seg_rules?.map((i) => i.seg_rule_creatives.length).reduce((k, v) => k + v, 0)} Creatives
            </div>
          </div>
        </div>
      </div>
      <div className={s.buttonsWrapper}>
        {location.pathname.includes('advertiser/audience') && !audience?.in_use ? (
          <CustomButton variant="primary" onClick={editAudienceHandler} size="240" className={s.editBtn}>
            Edit
          </CustomButton>
        ) : null}
        <CustomButton variant="outlined" onClick={onCloseModal} size="152">
          Close
        </CustomButton>
      </div>
    </ModalFullScreen>
  )
}

export default AudienceInfoModal
